<template>
  <div class="wrapper">
    <section class="answer-one answer">
      <div class="container answer__container">
        <div class="answer__block--title five--block-answer">
            <span class="levels__love-bg">
                <picture>
                    <source srcset="~@/assets/img/level-love-5.avif" type="image/avif">
                    <source srcset="~@/assets/img/level-love-5.webp" type="image/webp">
                    <img loading="lazy" src="~@/assets/img/level-love-5.png" class="image" width="54" height="166" alt="Love">
                </picture>
            </span>
          <h2 class="answer__title">Уровень 5</h2>
          <p class="answer__subtitle">Достаточный:</p></div>
        <div class="answer__content">
          <div class="process-bar__label">Потенциал любовной энергии</div>
          <div class="process-bar">
            <div class="process-bar__line result-5"></div>
            <div class="process-bar__value">97%</div>
          </div>
          <div class="process-bar-listing">
            <div class="process-bar-listing__title">Любовная энергия на данный момент:</div>
            <div class="process-bar-list__label">Любовь к себе</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-5_list_1"></div>
              <div class="process-bar-list__value">58%</div>
            </div>
            <div class="process-bar-list__label">Любовь к окружающим </div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-5_list_2"></div>
              <div class="process-bar-list__value">63%</div>
            </div>
            <div class="process-bar-list__label">Любовь к жизни</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-5_list_3"></div>
              <div class="process-bar-list__value">70%</div>
            </div>
          </div>
          <div class="text-icon">
            <img src="@/assets/img/svg/icon_1_text.svg" />
            <p>Потенциал вашей любовной энергии близок
              к максимуму! <span>Вы — осознанный человек, который умеет любить
              и ценить себя.</span></p>
          </div>
          <p class="answer__content--text">
            Вы не страдаете эгоизмом и так же хорошо относитесь к окружающим, как и к себе. У вас достаточный
            уровень любви, <span>однако часто вы притягиваете к себе слабых мужчин,</span> которые питаются вашей энергией и почти ничего не могут предложить взамен.<br /><br />
            Поскольку вы — ресурсная личность, то ваш партнер обычно решает, что может расслабиться и ничего не делать. <span>Сильный и уверенный типаж вы отпугиваете:</span> достойные кандидаты опасаются, что вы не откажетесь от своей роли воина и будете с ними постоянно соревноваться. Потому они даже не пытаются к вам подойти, а вам приходится довольствоваться теми, кто пользуется вашими ресурсами.
          </p>
          <div class="text-icon icon-top m28">
            <img src="@/assets/img/svg/icon_2_text.svg" />
            <p>Если вы не начнете поднимать свой уровень энергии любви, вы никогда не сможете войти
              в ресурсную женскую позицию. </p>
          </div>
          <p class="answer__content--text no-margin">Это значит, что вы продолжите
            и дальше <span>все тащить на себе, позволяя партнеру “садиться
            на шею”.</span> Вам следует повысить свой уровень до высокого, чтобы стать более мягкой и женственной, научиться не показывать свою силу и перестать соревноваться
            с мужчинами.
          </p>
          <p class="answer__content--text m28">Вам необходимо поверить в себя и в собственные силы, не соглашаться на все, что вам предлагают, а самой делать выбор. Только так вы сможете поднять свой уровень энергии любви. </p>
          <div class="block-text">
            <div class="block-text__title">Высокий уровень любви даст вам:</div>
            <div class="block-text__text">— здоровую самооценку;
            </div>
            <div class="block-text__text">
              — умение любить себя такой, какая вы есть;
            </div>
            <div class="block-text__text">
              — способность быть любимой;
            </div>
            <div class="block-text__text">
              — счастливые отношения;
            </div>
            <div class="block-text__text">
              — внутреннее равновесие;
            </div>
            <div class="block-text__text">
              — избавление от одиночества.
            </div>
          </div>

          <div class="rs-title">Персональные рекомендации для вас:</div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">01</div>
              <div class="rs-block__subtitle">Аффирмации для развития женственности. </div>
            </div>
            <div class="rs-block__text">Каждый день становитесь перед зеркалом и говорите своему отражению: “Я — настоящая женщина. Я красивая, привлекательная и интересная. Я мягкая, тонкая и чувствительная. Я разрешаю себе быть слабой. Я разрешаю себе быть неидеальной. Моя женская энергия растет каждый день!”</div>
          </div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">02</div>
              <div class="rs-block__subtitle icon_number"> Амулет
                <br />“Энергия любви”.</div>
            </div>
            <div class="rs-block__text icon_end">Он настраивается под энергетику будущей носительницы методом индивидуального заряда, поэтому работает точечно и целенаправленно <br>с ее личными задачами. Браслет <br>усилит вашу женскую и любовную энергию, поможет сохранять ее на стабильном уровне и притянет в <br>вашу жизнь достойного мужчину.<br>
              Как работает амулет и чем он вам поможет — читайте тут</div>
            <div class="more">
              <a class="info__button btn_rs btn" :href="url" onclick="ym(56736205,'reachGoal','amuletslovetest')">Заказать амулет</a>
            </div>
          </div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">03</div>
              <div class="rs-block__subtitle">Практика для гармонии со своим женским Я.</div>
            </div>
            <div class="rs-block__text">Уединитесь, закройте глаза и выпрямите спину. Сосредоточьте свое внимание на центре живота и направьте в эту зону всю свою энергию. Представьте, что она наполнена солнечно-оранжевым цветом. Он согревает живот своим теплом, которое медленно растекается по всему телу. Мысленно повторяйте фразу: “Я принимаю свою женскую природу и открываю в себе энергию Женщины!” Применяйте практику регулярно до получения очевидного результата.</div>
          </div>
        </div>
      </div>
    </section>
    <FooterResult />
  </div>
</template>

<script>
import FooterResult from "@/components/FooterResult";
export default {
  name: "Result5",
  components: {FooterResult},
  computed: {
    utm() {
      return this.$store.getters['utm']
    },
    url() {
      let link = 'https://store.taroirena.ru/shop/amulety/braslet-energiya-lyubvi/'
      if(this.utm.utm_source) {
        link += '?utm_source=' + this.utm.utm_source
      }
      if(this.utm.utm_medium) {
        link += '&utm_medium=' + this.utm.utm_medium
      }
      if(this.utm.utm_campaign) {
        link += '&utm_campaign=' + this.utm.utm_campaign
      }
      if(this.utm.utm_content) {
        link += '&utm_content=' + this.utm.utm_content
      }
      if(this.utm.utm_term) {
        link += '&utm_term=' + this.utm.utm_term
      }
      return link
    }
  }
}
</script>